import React from 'react';

import { DimensionComponent } from './DimensionComponent';
import { DimensionSeparator } from './DimensionSeparator';

export function ExpandableDimension(props: { first: readonly number[]; second: readonly number[] }) {
  return (
    <>
      <DimensionComponent value={props.first} />
      <DimensionSeparator />
      <DimensionComponent value={props.second} />
    </>
  );
}
